module.exports = __webpack_public_path__ + "static/img/bg.d584bede.jpg";